const validate = values => {
  const errors = {};
  if (!values.get('reason'))
    errors.reason = 'Please insert the reason';
  if (!values.get('reasonEx'))
    errors.reasonEx = 'Please choose an additional reason';
  if (values.get('reasonEx') && values.get('reasonEx') === 'その他（自由記入）' && !values.get('reasonExInput'))
    errors.reasonExInput = 'Please insert another reason';
  return errors;
};
export default validate;
